import * as React from "react";
import { Field, reduxForm, InjectedFormProps } from "redux-form";

import { TextInput } from "../../../components";
import validate from "../phone-input-form-validation";

import { PhoneInputProps } from "./PhoneInput";

export interface PhoneInputFormValues {
  source: string;
  country_code: string;
  phone: string;
}

export interface AugmentedPhoneInputFormProps
  extends InjectedFormProps<PhoneInputFormValues, PhoneInputProps>,
    PhoneInputProps {}

const PhoneInputForm = (props: AugmentedPhoneInputFormProps) => {
  return (
    <form className="phone-input__form" onSubmit={props.handleSubmit}>
      <Field component="input" type="hidden" name="source" />
      <Field
        component="select"
        name="country_code"
        className="phone-input__country-code-select"
      >
        {props.phonePrefixOptions}
      </Field>
      <Field
        component={TextInput}
        className="phone-input__phone-input"
        type="tel"
        name="phone"
        placeholder="Số điện thoại của bạn"
      />
      <button
        type="submit"
        className="phone-input__call-btn"
        disabled={props.submitting}
      >
        Call me!{" "}
        {props.submitting && <i className="fa fa-fw fa-pulse fa-spinner" />}
      </button>
    </form>
  );
};

export default reduxForm<PhoneInputFormValues, PhoneInputProps>({
  form: "phone-input",
  validate,
})(PhoneInputForm);



// WEBPACK FOOTER //
// ./src/routes/Step1/components/PhoneInputForm.tsx